<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUsers()
      vm.getOffices()
    })
  },
  methods: {
    getUsers () {
      this.$store.dispatch('getUsers')
    },
    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?11bf7d32